var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTagKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st0 {fill: #afb1b8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path2",
    className: "st0",
    x: 10,
    y: 9.4,
    width: 3.7,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path3",
    className: "st0",
    x: 7.1,
    y: 15.9,
    width: 4.3,
    height: 2.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path4",
    className: "st0",
    x: 7.1,
    y: 20.4,
    width: 4.3,
    height: 2.7,
    rx: 0.1,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "st0",
    d: "M12,.9c-4.6,0-7.5,2.4-7.5,5.5s2.6,5.5,7.5,5.5,7.5-2.4,7.5-5.5S16.9.9,12,.9ZM12,6.4c-.9,0-1.4-.7-1.4-1.7s.6-1.7,1.4-1.7,1.4.7,1.4,1.7-.6,1.7-1.4,1.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTagKey);
export default __webpack_public_path__ + "static/media/ico_tag_key.27134d397c404b0823f2f4925ebce4cf.svg";
export { ForwardRef as ReactComponent };